import { FormLabel } from '@/components/FormLabel'
import { FormRow } from '@/containers/forms/FormRow'
import { RadioGroup } from '@/containers/forms/RadioGroup'
import { useInsuranceParams } from '@/context/InsuranceParamsProvider'
import { useApp } from '@/hooks/useApp'
import { useAvailableProducts } from '@/hooks/useProducts'
import {
  FormControl,
  FormErrorMessage,
  Grid,
  Radio,
  Stack
} from '@chakra-ui/react'
import type { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos'
import { Product, RiskVariant, Selection } from 'BrokerTsLib/src/enums'
import type { FieldError } from 'BrokerTsLib/src/rhf'
import { useFormContext } from 'BrokerTsLib/src/rhf'

export const ParametersForm = () => {
  const { product, setProduct } = useApp()
  const { isDisabled, insuranceParams } = useInsuranceParams()
  const availableProducts = useAvailableProducts()

  const {
    setValue,
    register,
    formState: { errors },
    watch
  } = useFormContext<InsuranceParamsPropertyDto>()

  const variant = watch('property.type')

  const handleSelectProduct = (product: Product, variant: RiskVariant | null) => {
    setProduct(product)
    setValue('property.type', variant)

    if (insuranceParams)
      insuranceParams.generalParams.insuranceCategoryType = product
  }

  return (
    <Grid rowGap={16} w='100%'>
      <FormRow>
        <FormControl sx={{ gap: 4 }} isInvalid={!!errors.property?.type} isRequired>
          <FormLabel>Typ pojištění</FormLabel>

          <Stack spacing={4}>
            {availableProducts.includes(Product.PropertyInsurance) && <>
              <Radio
                isChecked={variant === RiskVariant.Household && product == Product.PropertyInsurance}
                onChange={() => {
                  handleSelectProduct(Product.PropertyInsurance, RiskVariant.Household)
                }}
                isDisabled={isDisabled}
              >
                Domácnost
              </Radio>

              <Radio
                isChecked={variant === RiskVariant.Realty && product == Product.PropertyInsurance}
                onChange={() => {
                  handleSelectProduct(Product.PropertyInsurance, RiskVariant.Realty)
                }}
                isDisabled={isDisabled}
              >
                Nemovitost
              </Radio>

              <Radio
                isChecked={variant === RiskVariant.HouseholdAndRealty && product == Product.PropertyInsurance}
                isDisabled={isDisabled}
                onChange={() => {
                  handleSelectProduct(Product.PropertyInsurance, RiskVariant.HouseholdAndRealty)
                }}
              >
                Domácnost + nemovitost
              </Radio>
            </>}

            {availableProducts.includes(Product.LiabilityInsurance) && (
              <Radio
                isChecked={product === Product.LiabilityInsurance}
                isDisabled={isDisabled}
                onChange={() => {
                  handleSelectProduct(Product.LiabilityInsurance, null)
                }}
              >
                Samostatná odpovědnost
              </Radio>
            )}
          </Stack>
          {/* </RadioGroup> */}

          {errors.property?.type && <FormErrorMessage>{(errors.property.type as FieldError).message}</FormErrorMessage>}
        </FormControl>

        {variant && product === Product.PropertyInsurance &&
          <FormControl sx={{ gap: 4 }} isInvalid={!!errors.property?.data?.realtyTypeId} isRequired>
            <FormLabel>Typ nemovitosti</FormLabel>

            <RadioGroup
              {...register('property.data.realtyTypeId')}
              isDisabled={isDisabled}
              onChange={e => setValue('property.data.realtyTypeId', parseInt(e))}
            >
              <Stack spacing={4}>
                <Radio value={Selection.RodinnyDum.toString()}>
                  Rodinný dům
                </Radio>
                <Radio value={Selection.Byt.toString()}>
                  Bytová jednotka
                </Radio>
                <Radio value={Selection.RekreacniObjekt.toString()}>
                  Rekreační objekt
                </Radio>
              </Stack>
            </RadioGroup>

            {errors.property?.data?.realtyTypeId && <FormErrorMessage>{errors.property.data.realtyTypeId.message}</FormErrorMessage>}

          </FormControl>
        }
      </FormRow>
    </Grid>
  )
}